'use client'

import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react'
import { Fragment } from 'react'

import { SidebarContent, SidebarItem, SidebarList } from '@/components/ui'
import type { MenuItem } from '@/utils/routes/menu'
import { ModuleMenuItems } from './ModuleMenuItems'
import { PortfolioMenu } from './PortfolioMenu'

type ModuleMenuProps = {
  activeMenu: string
  isCollapsed: boolean
  modulesByActor: MenuItem[]
  pathname: string
  selectedMenu?: MenuItem
  setActiveMenu: (menu: string) => void
  portfolioMenu: MenuItem[]
  hasPermissionToCreatePortfolio: boolean
  isOpenDialogCreatePortfolio: boolean
  setIsOpenDialogCreatePortfolio: (isOpen: boolean) => void
  handleCreatePortfolio: (data: { title: string; description?: string }) => void
  isPending: boolean
  hasProjectModule: boolean
}

export const ModuleMenu = ({
  activeMenu,
  isCollapsed,
  modulesByActor,
  pathname,
  selectedMenu,
  setActiveMenu,
  portfolioMenu,
  hasPermissionToCreatePortfolio,
  isOpenDialogCreatePortfolio,
  setIsOpenDialogCreatePortfolio,
  handleCreatePortfolio,
  isPending,
  hasProjectModule,
}: ModuleMenuProps) => {
  return (
    <SidebarContent>
      <SidebarList>
        <div className="flex flex-col gap-3">
          <span className="text-xs font-semibold uppercase text-system-grey-strong">
            Módulos
          </span>

          <SidebarList>
            {modulesByActor.map(({ icon: Icon, key, matchPattern, label }) => (
              <Fragment key={key}>
                <SidebarItem
                  className={!isCollapsed ? 'justify-between' : ''}
                  mode="outlined"
                  isActive={new RegExp(matchPattern).test(pathname)}
                  onClick={() => {
                    setActiveMenu(activeMenu === key ? '' : key)
                  }}
                >
                  {isCollapsed ? (
                    <Icon />
                  ) : (
                    <>
                      <div className="flex items-center gap-2">
                        <Icon className="size-5 md:size-6" />
                        {label}
                      </div>

                      {activeMenu === key ? (
                        <ChevronUpIcon className="size-5 md:size-6" />
                      ) : (
                        <ChevronDownIcon className="size-5 md:size-6" />
                      )}
                    </>
                  )}
                </SidebarItem>

                {activeMenu === key && (
                  <ModuleMenuItems
                    selectedMenu={selectedMenu}
                    pathname={pathname}
                  />
                )}
              </Fragment>
            ))}

            {hasProjectModule && (
              <PortfolioMenu
                activeMenu={activeMenu}
                isCollapsed={isCollapsed}
                pathname={pathname}
                portfolioMenu={portfolioMenu}
                setActiveMenu={setActiveMenu}
                hasPermissionToCreatePortfolio={hasPermissionToCreatePortfolio}
                isOpenDialogCreatePortfolio={isOpenDialogCreatePortfolio}
                setIsOpenDialogCreatePortfolio={setIsOpenDialogCreatePortfolio}
                handleCreatePortfolio={handleCreatePortfolio}
                isPending={isPending}
              />
            )}
          </SidebarList>
        </div>
      </SidebarList>
    </SidebarContent>
  )
}

ModuleMenu.displayName = 'ModuleMenu'
